import { StarCrescentIcon } from './StarCrescentIcon';

/**
 * author: Nick
 * id 94C88D65-EE50-4DC5-920D-FA4181DE0413
 * name star-crescent
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-crescent.svg
 * tags
 * - Religion 
 */
export const ReligionIslamicIcon = StarCrescentIcon;
export default ReligionIslamicIcon